/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

import AddLabelModal from "components/Common/Modal/AddLabelModal";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import { assetImages } from "constants";
import ConversationNewMailPopup from "components/Common/Popup/ConversationNewMailPopup";
import AppUserListHeader from "../Header/AppUserListHeader";
import AppUserListFilterPopup from "../Popup/AppUserListFilterPopup";
import { getPublicIP } from "helper/AuthHelper/AuthHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const AppUserListBody = () => {
  const { t, i18n } = useTranslation(); //for translation

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [appUserList, setAppUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectedUserEmails, setSelectedUserEmails] = useState("");
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  //customize the default page size
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [totalCount, setTotalCount] = useState(0);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all contacts
  const getAllAppUsers = async (
    start = 0,
    limit = 10,
    isPaginationChange = false
  ) => {
    try {
      if (!isPaginationChange) {
        setIsLoading(true);
      }

      const userPublicIp = await getPublicIP();

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_APP_USERS +
        `?token=${token}&userip=${userPublicIp}&modulefrom=backend&start=${start}&limit=${limit}`;

      console.log("url of app user list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in app user list------>", response);

      if (response.status) {
        setMessageType("success");
        setAppUserList(response.data);
        setTotalCount(response.totalrecords);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      if (!isPaginationChange) {
        setIsLoading(false);
      }
      setShowAlert(true);
    }
  };

  // get user by filter
  const getUsersByFilter = async (
    start = 0,
    limit = 10,
    isPaginationChange = false
  ) => {
    try {
      if (!isPaginationChange) {
        setIsLoading(true);
      }

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_USERS +
        `?token=${token}&modulefrom=backend&start=${start}&limit=${limit}`;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setAppUserList(response.data);
        setTotalCount(response.totalrecords);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      if (!isPaginationChange) {
        setIsLoading(false);
      }
    }
  };

  //* function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedUserList = [...appUserList];

    const rowIndex = updatedUserList.findIndex(
      (user) => user._id === row.original._id
    );

    if (rowIndex !== -1) {
      updatedUserList[rowIndex].rank = value;

      setAppUserList(updatedUserList);
    }
  };

  //* function for update rank
  const updateRankHandler = async (e) => {
    if (selectedUserIds.length > 0) {
      const userPublicIp = await getPublicIP();

      const userListToBeUpdate = appUserList
        .filter((item) => selectedUserIds.includes(item._id))
        .map((item) => {
          return {
            _id: item._id,
            rank: item.rank,
          };
        });

      let userData = {
        userlist: userListToBeUpdate,
      };

      let requestURL =
        url.API_BASE_URL +
        url.API_BULK_UPDATE_USER +
        `?token=${token}&userip=${userPublicIp}`;

      const response = await putData(requestURL, userData);

      console.log("response in update rank handler------>", response);

      if (response.status) {
        setMessageType("success");

        setTimeout(() => {
          setAppUserList((prev) => replaceListByIds(prev, response.data));
        }, 1500);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);

      setRowSelection({});
      setSelectedUserIds([]);
    } else {
      setMessageType("error");
      setAlertMessage("Please select user for change rank");
      setShowAlert(true);
    }
  };

  //* function for change status
  const changeStatusHandler = async (statusInfo = "") => {
    if (selectedUserIds.length > 0) {
      const userPublicIp = await getPublicIP();

      const userListToBeUpdate = appUserList.filter((item) =>
        selectedUserIds.includes(item._id)
      );

      let userData = {
        userlist: userListToBeUpdate,
        status: statusInfo,
      };

      let requestURL =
        url.API_BASE_URL +
        url.API_BULK_UPDATE_USER +
        `?token=${token}&userip=${userPublicIp}`;

      const response = await putData(requestURL, userData);

      console.log("response in change status handler------>", response);

      if (response.status) {
        setMessageType("success");

        setTimeout(() => {
          setAppUserList((prev) => replaceListByIds(prev, response.data));
        }, 1500);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);

      setRowSelection({});
      setSelectedUserIds([]);
    } else {
      setMessageType("error");
      setAlertMessage("Please select user for update status");
      setShowAlert(true);
    }
  };

  //function for remove tag from app user
  const removeTagFromAccount = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_APP_USER;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedUserId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setAppUserList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  const afterEmailClose = () => {
    setRowSelection({});
    setSelectedUserIds([]);
    setSelectedUserEmails("");
  };

  //reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedUserIds([]);
    setSelectedUserEmails("");
    setPagination({ pageIndex: 0, pageSize: 10 }); // page reset
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (reloadData) {
      getAllAppUsers(
        pagination.pageIndex * pagination.pageSize,
        pagination.pageSize,
        false
      );
      setReloadData(false);
    }
  }, [reloadData, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getUsersByFilter(0, 10, false);
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (jsonFilterQuery.length === 0) {
      getAllAppUsers(0, 10, false); // initial call
    }
  }, []);

  useEffect(() => {
    // pagination change handler
    if (pagination.pageIndex !== 0 || pagination.pageSize !== 10) {
      if (jsonFilterQuery.length > 0) {
        getUsersByFilter(
          pagination.pageIndex * pagination.pageSize,
          pagination.pageSize,
          true
        );
      } else {
        getAllAppUsers(
          pagination.pageIndex * pagination.pageSize,
          pagination.pageSize,
          true
        );
      }
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: t("Name"),
        Cell: ({ renderedCellValue, row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              width: "150px",
            }}
          >
            <img
              height={30}
              width={30}
              src={
                row.original.userimage
                  ? url.SERVER_URL + row.original.userimage
                  : assetImages.defaultUser
              }
              loading="lazy"
              style={{ borderRadius: "50%" }}
            />
            <span>{renderedCellValue}</span>
          </Box>
        ),
      },
      {
        accessorKey: "surname",
        header: t("Surname"),
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        size: 300,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedUserId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromAccount([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedUserId &&
                          selectedUserId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedUserIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "userrole",
        header: t("Role"),
      },
      {
        accessorKey: "rank",
        header: t("Rank"),
        Cell: ({ renderedCellValue, row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              width: "150px",
            }}
          >
            <input
              // loading="lazy"
              type="number"
              name="rank"
              id="rank"
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
            />
          </Box>
        ),
      },
      {
        accessorKey: "userstatus",
        header: t("Status"),
      },
      {
        accessorKey: "email",
        header: t("Email"),
      },
      {
        accessorKey: "subscribetomail",
        header: t("Subscribe to Mail"),
      },
      {
        accessorKey: "position",
        header: t("Position"),
      },
      {
        accessorKey: "company",
        header: t("Clinic"),
      },
      {
        accessorKey: "costperhour",
        header: t("Cost"),
      },
      {
        accessorKey: "phone",
        header: t("Phone"),
      },
      {
        accessorKey: "city",
        header: t("Location"),
      },
      {
        accessorKey: "country",
        header: t("Country"),
      },
      {
        accessorKey: "logintime",
        header: t("Login Time"),
      },
      {
        accessorKey: "logindate",
        header: t("Login Date"),
      },
      {
        accessorKey: "browser",
        header: t("Login Browser"),
      },
      {
        accessorKey: "userip",
        header: t("Login Ip"),
      },
    ],
    [appUserList, selectedTagId, i18n.language]
  );

  useEffect(() => {
    //do something when the row selection changes...
    // console.info("rowSelection", rowSelection);
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      const selectUserIds = selectedIdsArray.map((id) => {
        const [userId] = id.split("-");
        return userId;
      });
      const selectUserEmails = selectedIdsArray.map((id) => {
        const [, userEmail] = id.split("-");
        return userEmail;
      });
      setSelectedUserIds(selectUserIds);
      const selectUserEmailString = selectUserEmails.join(",");
      setSelectedUserEmails(selectUserEmailString);
    } else {
      setSelectedUserIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            {/* ---- header ----*/}
            <AppUserListHeader
              reloadUserList={resetFilterData}
              changeStatusHandler={changeStatusHandler}
              // changeAdminStatusHandler={changeAdminStatusHandler}
              updateRankHandler={updateRankHandler}
              selectedUserIds={selectedUserIds}
              jsonFilterQuery={jsonFilterQuery}
            />
            {/* ---- table with pagination section start ---- */}
            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={appUserList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => `${row._id}-${row.email}`} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, pagination }} //pass our managed row selection state to the table to use
                  onPaginationChange={setPagination}
                  enablePagination
                  manualPagination
                  rowCount={totalCount}
                  enableRowActions // show the action column
                  //localization={MRT_Localization_ES} // localization
                  renderRowActionMenuItems={({ row }) => {
                    const [appUserId] = row.id.split("-");

                    return [
                      <MenuItem key="Profile">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/profile/${appUserId}`}
                        >
                          {t("Manage Profile")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="avalibility">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/availability/${appUserId}`}
                        >
                          {t("Manage Schedule")}
                        </Link>
                      </MenuItem>,
                      // <MenuItem key="CV">
                      //   <Link
                      //     className="dropdown-item"
                      //     to={`/admin/appuser/cv/${appUserId}`}
                      //   >
                      //     {t("Manage CV")}
                      //   </Link>
                      // </MenuItem>,
                      <MenuItem key="medical">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/medical/${appUserId}`}
                        >
                          {t("Manage Medical")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="Privacy">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/privacy/${appUserId}`}
                        >
                          {t("Manage Privacy")}
                        </Link>
                      </MenuItem>,

                      <MenuItem key="Password">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/password/${appUserId}`}
                        >
                          {t("Manage Password")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="settings">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/settings/${appUserId}`}
                        >
                          {t("Manage Settings")}
                        </Link>
                      </MenuItem>,
                      // <MenuItem key="survey">
                      //   <Link
                      //     className="dropdown-item"
                      //     to={`/admin/appuser/surveyinvites/${appUserId}`}
                      //   >
                      //     {t("View Survey Invites")}
                      //   </Link>
                      // </MenuItem>,
                    ];
                  }} // action columns menu items
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
            {/* ---- table with pagination section end ---- */}
          </div>
        </section>
        {/* ======== popups and modals area ======== */}
        {/* ------ add label modal-------- */}
        <AddLabelModal
          selectedIds={selectedUserIds}
          moduleName="appuser"
          afterTagModalClose={afterModalActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setSelectedUserIds([]);
            setSelectedUserEmails("");
            setRowSelection({});
          }}
        />
        {/* ------- filter popup ------- */}
        <AppUserListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadLeadList={resetFilterData}
          moduleSlug="appuserlist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />
        {/* ---- new mail modal ------- */}
        <ConversationNewMailPopup
          contactPersonEmail={selectedUserEmails}
          reloadList={afterEmailClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};
export default AppUserListBody;
